/**
 * Container for Onboarding page
 *
 * @module containers/Onboarding
 */
import PropTypes from 'prop-types';
import React from 'react';
import { IntlProvider } from 'react-intl';

import MetaTags from '../../components/MetaTags/MetaTags';
import OverlayContainer from '../../containers/OverlayContainer/OverlayContainer';
import { AsyncDomain } from '../../domains';

export default class extends React.Component {
  /**
   * @property {Node} children - the children nodes appended by React Router
   * @property {string} locale - localization/internationalization prop
   * @property {object} i18nMessages - localization/internationalization prop
   */
  static propTypes = {
    children: PropTypes.node,
    locale: PropTypes.string,
    i18nMessages: PropTypes.object,
    defaultLocale: PropTypes.string,
    isDebugMenuEnabled: PropTypes.bool,
    showTuner: PropTypes.bool,
  };

  render() {
    return (
      <IntlProvider
        defaultLocale={this.props.defaultLocale}
        locale={this.props.locale}
        messages={this.props.i18nMessages}
      >
        <div className='App'>
          <MetaTags />
          <div className='region-overlay'>
            <OverlayContainer />
          </div>
          {/* developer debug menu enabled at buildtime by setting debugMenuEnabled: true*/}
          {this.props.isDebugMenuEnabled && (
            <AsyncDomain domain='debug' key='DebugMenu' component='DebugMenu' full={true} />
          )}
          {this.props.children}
          {this.props.showTuner && (
            <div key='region-bottom-bar' className='region-bottomBar'>
              <AsyncDomain domain='playback' key='tuner-controls' component='Tuner' />
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}
